export type PossibleTypesResultData = {
  possibleTypes: {
    Account: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BeneficiaryAccount",
      "BrexExternalAccountDetails",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "MercuryExternalAccountDetails",
      "NoticeAccountAsset",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SavingsAsset",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
      "TermDepositAsset",
    ];
    AccountsSummaryGroup: [
      "AccountTypeAccountsSummaryGroup",
      "AssetClassAccountsSummaryGroup",
      "BusinessEntityAccountsSummaryGroup",
      "CurrencyAccountsSummaryGroup",
      "ProviderAccountsSummaryGroup",
    ];
    ApprovalTarget: ["Payout", "Transfer"];
    Asset: [
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "SavingsAsset",
      "TermDepositAsset",
    ];
    AssetRule: [
      "AlertAssetRule",
      "RecurringWithdrawalAssetRule",
      "TopUpAssetRule",
    ];
    BatchUpdateAssetResult: [
      "BatchUpdateAssetErrorResult",
      "BatchUpdateAssetSuccessResult",
    ];
    EburyTradeDetails: [
      "EburyDrawdownDetails",
      "EburyFixedForwardDetails",
      "EburyNDFDetails",
      "EburySpotTradeDetails",
      "EburyWindowForwardDetails",
    ];
    EventActor: [
      "EventActorExternalSystem",
      "EventActorExternalUser",
      "EventActorInternalUser",
      "EventActorScheduledJob",
      "EventActorStandaloneJob",
    ];
    ExternalAccountDetails: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BrexExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
    ];
    ExternalBankAccountDataInstitution: [
      "AkahuExternalBankAccountDataInstitution",
      "BrexExternalBankAccountDataInstitution",
      "MercuryExternalBankAccountDataInstitution",
      "QuilttExternalBankAccountDataInstitution",
      "RampExternalBankAccountDataInstitution",
      "SaltEdgeExternalBankAccountDataInstitution",
      "SissExternalBankAccountDataInstitution",
      "SkriptExternalBankAccountDataInstitution",
      "StripeExternalBankAccountDataInstitution",
    ];
    FXHedge: ["ExternalFXHedge", "ManagedFXHedge"];
    FXProvider: ["CurrencycloudAccount", "EburyClient"];
    FXRateDataPoint: ["FXRateDataPointDate", "FXRateDataPointDateTime"];
    FXTrade: ["CurrencycloudFXTrade", "EburyFXTrade"];
    FXTradeQuote: [
      "FXTradeFirmQuote",
      "FXTradeQuoteEstimate",
      "FXTradeSyntheticQuote",
    ];
    FileImportTransactionOption: [
      "FileImportTransactionAnnotationOption",
      "FileImportTransactionBlackrockUnitOrderOption",
      "FileImportTransactionNewDepositOption",
      "FileImportTransactionPayoutOption",
      "FileImportTransactionTransferNewOption",
      "FileImportTransactionTransferOption",
      "FileImportTransactionWestpacPaymentInstructionOption",
    ];
    FundMovement: ["Deposit", "EburyFXTrade", "Payout", "Transfer"];
    ImportFile: [
      "MacquarieTransactionImportFile",
      "WestpacTransactionImportFile",
    ];
    LedgerAccount: [
      "AssetLedgerAccount",
      "BeneficiaryLedgerAccount",
      "CustodyLedgerAccount",
      "FXMarginProviderLedgerAccount",
      "OrganisationLedgerAccount",
    ];
    Node: [
      "ActivityStatement",
      "Address",
      "AssetLedgerAccount",
      "BalanceStatement",
      "BankAccountProduct",
      "BeneficiaryAccount",
      "BeneficiaryLedgerAccount",
      "BlackrockUnitOrder",
      "BusinessEntity",
      "CurrencycloudFXTrade",
      "CustodyAccount",
      "CustodyLedgerAccount",
      "Deposit",
      "EburyAccount",
      "EburyBeneficiary",
      "EburyFXTrade",
      "Event",
      "ExternalBankAccountAsset",
      "ExternalFXHedge",
      "FXAsset",
      "FXMarginProviderLedgerAccount",
      "FixedIncomeFundAsset",
      "FundProduct",
      "LedgerTransaction",
      "MacquarieTransactionImportFile",
      "ManagedFXHedge",
      "MonthlyStatement",
      "NoticeAccountAsset",
      "Organisation",
      "OrganisationLedgerAccount",
      "PaymentInstructionFile",
      "Payout",
      "SavingsAsset",
      "StatementBatch",
      "TermDepositAsset",
      "TermDepositProduct",
      "Transaction",
      "Transfer",
      "TransferGroup",
      "UnknownEventObject",
      "UsRIARecord",
      "UserProfile",
      "WestpacPaymentInstruction",
      "WestpacTransactionImportFile",
    ];
    PaymentIdentifier: [
      "AuBsbPaymentIdentifier",
      "AuPayIdPaymentIdentifier",
      "AuUnitFundPaymentIdentifier",
      "IbanPaymentIdentifier",
      "SwiftBicPaymentIdentifier",
      "SwiftPaymentIdentifier",
      "UsAbaPaymentIdentifier",
    ];
    Product: ["BankAccountProduct", "FundProduct", "TermDepositProduct"];
    SettlementAccount: ["BeneficiaryAccount", "FXAsset", "SavingsAsset"];
    Statement: ["ActivityStatement", "BalanceStatement", "MonthlyStatement"];
    TermDepositMaturityInstructions: [
      "TermDepositMaturityInstructionsRollover",
      "TermDepositMaturityInstructionsRolloverPrinciple",
      "TermDepositMaturityInstructionsTransfer",
    ];
    TimeLogUpdate: [
      "BaseTimeLogUpdate",
      "FXTradeTimeLogUpdate",
      "PayoutTimeLogUpdate",
    ];
    TransferUnit: ["TransferUnitCurrency", "TransferUnitFund"];
    UpcomingPolicyTransaction: ["Payout", "Transfer"];
    UserTask: [
      "AlertRuleUserTask",
      "ApprovalRequestUserTask",
      "ExternalAccountRelinkingUserTask",
      "FXFundingUserTask",
      "GroupedApprovalRequestUserTask",
      "GroupedExternalAccountRelinkingUserTask",
      "ManageAllocationsUserTask",
      "RuleWithdrawalReplacedUserTask",
    ];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    Account: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BeneficiaryAccount",
      "BrexExternalAccountDetails",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "MercuryExternalAccountDetails",
      "NoticeAccountAsset",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SavingsAsset",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
      "TermDepositAsset",
    ],
    AccountsSummaryGroup: [
      "AccountTypeAccountsSummaryGroup",
      "AssetClassAccountsSummaryGroup",
      "BusinessEntityAccountsSummaryGroup",
      "CurrencyAccountsSummaryGroup",
      "ProviderAccountsSummaryGroup",
    ],
    ApprovalTarget: ["Payout", "Transfer"],
    Asset: [
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "SavingsAsset",
      "TermDepositAsset",
    ],
    AssetRule: [
      "AlertAssetRule",
      "RecurringWithdrawalAssetRule",
      "TopUpAssetRule",
    ],
    BatchUpdateAssetResult: [
      "BatchUpdateAssetErrorResult",
      "BatchUpdateAssetSuccessResult",
    ],
    EburyTradeDetails: [
      "EburyDrawdownDetails",
      "EburyFixedForwardDetails",
      "EburyNDFDetails",
      "EburySpotTradeDetails",
      "EburyWindowForwardDetails",
    ],
    EventActor: [
      "EventActorExternalSystem",
      "EventActorExternalUser",
      "EventActorInternalUser",
      "EventActorScheduledJob",
      "EventActorStandaloneJob",
    ],
    ExternalAccountDetails: [
      "AirwallexExternalAccountDetails",
      "AkahuExternalAccountDetails",
      "BrexExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "RampExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
    ],
    ExternalBankAccountDataInstitution: [
      "AkahuExternalBankAccountDataInstitution",
      "BrexExternalBankAccountDataInstitution",
      "MercuryExternalBankAccountDataInstitution",
      "QuilttExternalBankAccountDataInstitution",
      "RampExternalBankAccountDataInstitution",
      "SaltEdgeExternalBankAccountDataInstitution",
      "SissExternalBankAccountDataInstitution",
      "SkriptExternalBankAccountDataInstitution",
      "StripeExternalBankAccountDataInstitution",
    ],
    FXHedge: ["ExternalFXHedge", "ManagedFXHedge"],
    FXProvider: ["CurrencycloudAccount", "EburyClient"],
    FXRateDataPoint: ["FXRateDataPointDate", "FXRateDataPointDateTime"],
    FXTrade: ["CurrencycloudFXTrade", "EburyFXTrade"],
    FXTradeQuote: [
      "FXTradeFirmQuote",
      "FXTradeQuoteEstimate",
      "FXTradeSyntheticQuote",
    ],
    FileImportTransactionOption: [
      "FileImportTransactionAnnotationOption",
      "FileImportTransactionBlackrockUnitOrderOption",
      "FileImportTransactionNewDepositOption",
      "FileImportTransactionPayoutOption",
      "FileImportTransactionTransferNewOption",
      "FileImportTransactionTransferOption",
      "FileImportTransactionWestpacPaymentInstructionOption",
    ],
    FundMovement: ["Deposit", "EburyFXTrade", "Payout", "Transfer"],
    ImportFile: [
      "MacquarieTransactionImportFile",
      "WestpacTransactionImportFile",
    ],
    LedgerAccount: [
      "AssetLedgerAccount",
      "BeneficiaryLedgerAccount",
      "CustodyLedgerAccount",
      "FXMarginProviderLedgerAccount",
      "OrganisationLedgerAccount",
    ],
    Node: [
      "ActivityStatement",
      "Address",
      "AssetLedgerAccount",
      "BalanceStatement",
      "BankAccountProduct",
      "BeneficiaryAccount",
      "BeneficiaryLedgerAccount",
      "BlackrockUnitOrder",
      "BusinessEntity",
      "CurrencycloudFXTrade",
      "CustodyAccount",
      "CustodyLedgerAccount",
      "Deposit",
      "EburyAccount",
      "EburyBeneficiary",
      "EburyFXTrade",
      "Event",
      "ExternalBankAccountAsset",
      "ExternalFXHedge",
      "FXAsset",
      "FXMarginProviderLedgerAccount",
      "FixedIncomeFundAsset",
      "FundProduct",
      "LedgerTransaction",
      "MacquarieTransactionImportFile",
      "ManagedFXHedge",
      "MonthlyStatement",
      "NoticeAccountAsset",
      "Organisation",
      "OrganisationLedgerAccount",
      "PaymentInstructionFile",
      "Payout",
      "SavingsAsset",
      "StatementBatch",
      "TermDepositAsset",
      "TermDepositProduct",
      "Transaction",
      "Transfer",
      "TransferGroup",
      "UnknownEventObject",
      "UsRIARecord",
      "UserProfile",
      "WestpacPaymentInstruction",
      "WestpacTransactionImportFile",
    ],
    PaymentIdentifier: [
      "AuBsbPaymentIdentifier",
      "AuPayIdPaymentIdentifier",
      "AuUnitFundPaymentIdentifier",
      "IbanPaymentIdentifier",
      "SwiftBicPaymentIdentifier",
      "SwiftPaymentIdentifier",
      "UsAbaPaymentIdentifier",
    ],
    Product: ["BankAccountProduct", "FundProduct", "TermDepositProduct"],
    SettlementAccount: ["BeneficiaryAccount", "FXAsset", "SavingsAsset"],
    Statement: ["ActivityStatement", "BalanceStatement", "MonthlyStatement"],
    TermDepositMaturityInstructions: [
      "TermDepositMaturityInstructionsRollover",
      "TermDepositMaturityInstructionsRolloverPrinciple",
      "TermDepositMaturityInstructionsTransfer",
    ],
    TimeLogUpdate: [
      "BaseTimeLogUpdate",
      "FXTradeTimeLogUpdate",
      "PayoutTimeLogUpdate",
    ],
    TransferUnit: ["TransferUnitCurrency", "TransferUnitFund"],
    UpcomingPolicyTransaction: ["Payout", "Transfer"],
    UserTask: [
      "AlertRuleUserTask",
      "ApprovalRequestUserTask",
      "ExternalAccountRelinkingUserTask",
      "FXFundingUserTask",
      "GroupedApprovalRequestUserTask",
      "GroupedExternalAccountRelinkingUserTask",
      "ManageAllocationsUserTask",
      "RuleWithdrawalReplacedUserTask",
    ],
  },
};
export default result;
